import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { JwtService } from '@ecosure-suite/shared/util-auth';
import {
  AuthFacade,
  User
} from '@ecosure-suite/back-office/auth/data-access-auth';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {
  constructor(private jwtService: JwtService, private authService: AuthFacade) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return !this.authService.hasValidAccessToken();
  }
}
